import useApiQuery from 'shared/hooks/use-api-query';
import companiesKeys from '../util/companies-keys';
import {AccessControlProps} from 'modules/access-controls/types';

const useCompanyAccessControls = (companyId: string) => {
  return useApiQuery<AccessControlProps[]>({
    url: `/access-controls/companies/${companyId}`,
    queryKey: companiesKeys.accessControls(companyId),
  });
};

export default useCompanyAccessControls;
